/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFiltrosUnidades from './entidades/filtrosUnidades';
import IUnidadesCompleta from './entidades/unidadCompleta';
import IUnidades from './entidades/unidades';

export default class ModeloUnidades {
    public consultarUnidades() {
        return manejadorRest<IRespuesta<IUnidades>>(() => negocio.get('Unidad/ConsultarListaUnidad'), true);
    }
    public crearUnidades(unidades: IUnidades) {
        return manejadorRest<IRespuesta<IUnidades>>(() => negocio.post('Unidad/GuardarUnidad', unidades), true);
    }
    public editarUnidades(unidades: IUnidades) {
        return manejadorRest<IRespuesta<IUnidades>>(() => negocio.put('Unidad/EditarUnidad', unidades), true);
    }
    public eliminarUnidades(unidades: IUnidades) {
        return manejadorRest<IRespuesta<IUnidades>>(() => negocio.delete('Unidad/EliminarUnidad', unidades), true);
    }
    public consultarUnidadesCompuesta() {
        return manejadorRest<IRespuesta<IUnidadesCompleta>>(() => negocio.get('Unidad/ConsultarUnidadCompuesta'), true);
    }
    public consultarUnidadesFiltro(filtrosUnidades: IFiltrosUnidades) {
        return manejadorRest<IRespuesta<IUnidades>>(
            () => negocio.post('Unidad/ConsultarUnidadFitro', filtrosUnidades),
            true
        );   
    }

    public consultarUnidadesCompuestaPorEmpresa(unidades: Partial<IUnidades>) {
        return manejadorRest<IRespuesta<IUnidadesCompleta>>(() => negocio.post('Unidad/ConsultarUnidadCompuestaPorEmpresa',unidades), true);
    }
}
